import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import ReaderQuestionNewsfeedItem from "./reader_question/reader_question_newsfeed_item";

/*
 * As of now, we only show updates for asking Reader questions. If in the future
 * we want to show updates for asking Author questions too, this component can
 * be expanded to accommodate the other type of question.
 *
 * See community_answer_newsfeed_item.js.jsx for question category considerations
 *
 */
export default GrComponentFactory.createClass({
  displayName: "CommunityQuestionNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape(GrPropTypes.communityQuestion()),
  },

  render() {
    return <ReaderQuestionNewsfeedItem {...this.props} />;
  },
});
